/*
 * SanMag - estimare livrare. Un singur modul pentru pagina de produs si cos.
 * Fara apeluri externe: ora Iasi se ia din Intl (Europe/Bucharest).
 *
 * Marcaj asteptat:
 *   <span data-delivery-estimate data-min-days="{{ min }}" data-max-days="{{ max }}">
 *     <span data-delivery-output></span>
 *   </span>
 * Optional, in acelasi container: <span data-delivery-import hidden></span>
 * Optional, in pagina de cos:     <span data-delivery-note></span>
 */
(function () {
  'use strict';

  var ZILE = ['Du', 'Lu', 'Ma', 'Mi', 'Jo', 'Vi', 'Sa'];
  var LUNI = ['Ian.', 'Feb.', 'Mart.', 'Apr.', 'Mai', 'Iun.', 'Iul.', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];

  var CUTOFF_HOUR = 14;   // comenzile dupa ora 14:00 pleaca a doua zi lucratoare
  var PRAG_IMPORT = 10;   // zile min peste aceasta valoare => produs adus din import

  var TXT_FARA_TERMEN = 'Termenul se confirmă după verificarea stocului';
  var TXT_IMPORT = 'Produs adus din import, termenul de livrare este mai lung.';
  var TXT_PROP_FARA_TERMEN = 'se confirmă după verificarea stocului';
  var TXT_PROP_IMPORT = 'produs din import';
  var TXT_NOTA_MIXTA = 'Termenele sunt estimate pentru fiecare produs în parte. Produsele pot fi livrate în una sau mai multe expedieri.';

  function acumInIasi() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Bucharest',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date());
      var v = {};
      parts.forEach(function (p) { v[p.type] = p.value; });
      return new Date(+v.year, +v.month - 1, +v.day, +v.hour, +v.minute, 0, 0);
    } catch (e) {
      return new Date();
    }
  }

  function esteWeekend(d) { var z = d.getDay(); return z === 0 || z === 6; }

  function urmatoareaZiLucratoare(d) {
    var r = new Date(d);
    while (esteWeekend(r)) r.setDate(r.getDate() + 1);
    return r;
  }

  function ziDeStart() {
    var d = acumInIasi();
    if (d.getHours() >= CUTOFF_HOUR) d.setDate(d.getDate() + 1);
    return urmatoareaZiLucratoare(d);
  }

  function adaugaZileLucratoare(start, n) {
    var d = urmatoareaZiLucratoare(start);
    var adaugate = 0;
    while (adaugate < n) {
      d.setDate(d.getDate() + 1);
      if (!esteWeekend(d)) adaugate++;
    }
    return d;
  }

  function formateaza(d) {
    return ZILE[d.getDay()] + ', ' + d.getDate() + ' ' + LUNI[d.getMonth()];
  }

  /* null = fara termen (stoc de verificat). Altfel { text, esteImport, zileMin, zileMax }. */
  function calculeaza(minZile, maxZile) {
    var a = parseInt(minZile, 10);
    var b = parseInt(maxZile, 10);
    if (isNaN(a) && isNaN(b)) return null;
    if (isNaN(a)) a = b;
    if (isNaN(b)) b = a;
    if (a < 0 || b < 0) return null;
    if (b < a) { var t = a; a = b; b = t; }

    var start = ziDeStart();
    var dMin = adaugaZileLucratoare(start, a);
    var dMax = adaugaZileLucratoare(start, b);

    return {
      text: a === b ? formateaza(dMin) : formateaza(dMin) + ' - ' + formateaza(dMax),
      esteImport: a > PRAG_IMPORT,
      zileMin: a,
      zileMax: b
    };
  }

  /* Sectiunea de produs poate contine mai multe formulare de adaugare in cos,
     asa ca nu cautam formularul, ci direct campurile ascunse din acelasi bloc de produs. */
  function domeniuProdus(el) {
    return el.closest('product-info') || el.closest('[id^="shopify-section"]') || document;
  }

  /* Textul salvat pe comanda: ajunge in checkout, in admin si in emailuri. */
  function textProprietate(rez) {
    if (!rez) return TXT_PROP_FARA_TERMEN;
    return rez.esteImport ? rez.text + ' (' + TXT_PROP_IMPORT + ')' : rez.text;
  }

  function randeaza(scope) {
    var radacina = scope || document;
    var termeneDiferite = {};
    var nrProduse = 0;

    var noduri = radacina.querySelectorAll('[data-delivery-estimate]');
    Array.prototype.forEach.call(noduri, function (el) {
      var rez = calculeaza(el.getAttribute('data-min-days'), el.getAttribute('data-max-days'));
      var tinta = el.querySelector('[data-delivery-output]') || el;

      tinta.textContent = rez ? rez.text : TXT_FARA_TERMEN;
      el.setAttribute('data-delivery-state', rez ? (rez.esteImport ? 'import' : 'stoc') : 'necunoscut');

      nrProduse++;
      termeneDiferite[rez ? rez.text : 'necunoscut'] = true;

      var notaImport = el.querySelector('[data-delivery-import]');
      if (notaImport) {
        if (rez && rez.esteImport) {
          notaImport.textContent = TXT_IMPORT;
          notaImport.hidden = false;
        } else {
          notaImport.hidden = true;
        }
      }

      // Pagina de produs: trimitem estimarea mai departe in comanda, checkout si emailuri.
      var campText = domeniuProdus(el).querySelector('[data-delivery-property]');
      if (campText) campText.value = textProprietate(rez);
    });

    // Nota din cos apare doar cand comanda are termene diferite intre produse.
    var note = radacina.querySelectorAll('[data-delivery-note]');
    Array.prototype.forEach.call(note, function (el) {
      var arataNota = nrProduse > 1 && Object.keys(termeneDiferite).length > 1;
      el.textContent = arataNota ? TXT_NOTA_MIXTA : '';
      el.hidden = !arataNota;
    });
  }

  window.SanMagDelivery = { calculeaza: calculeaza, randeaza: randeaza, formateaza: formateaza };

  function porneste() { randeaza(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', porneste);
  } else {
    porneste();
  }

  // Cosul Dawn se re-randeaza prin Section Rendering API; recalculam dupa fiecare update.
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.PUB_SUB_EVENTS || typeof window.subscribe !== 'function') return;
    ['cartUpdate', 'variantChange'].forEach(function (ev) {
      if (!window.PUB_SUB_EVENTS[ev]) return;
      window.subscribe(window.PUB_SUB_EVENTS[ev], function () {
        setTimeout(function () { randeaza(); }, 0);
      });
    });
  });

  // Plasa de siguranta daca tema inlocuieste noduri fara sa publice evenimentul.
  if (window.MutationObserver) {
    var programat = false;
    new MutationObserver(function (mutatii) {
      if (programat) return;
      var relevant = mutatii.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (n.hasAttribute('data-delivery-estimate') || n.querySelector('[data-delivery-estimate]'));
        });
      });
      if (!relevant) return;
      programat = true;
      setTimeout(function () { programat = false; randeaza(); }, 50);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
